import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

/**
 * The "Send" header action — borrower-facing links generated here and handed
 * off. Each entry lands on the send screen for that link kind, which mints the
 * unique URL and collects the prefill.
 *
 * Ported from tpo-portal-frontend `AuthenticatedDashboard/navItems.js`, where it
 * sits alongside that app's nav config. It lives in its own module here because
 * lendmarq-los builds its nav inline in AuthenticatedDashboard.js.
 *
 * `tone` selects the icon tile's tint pair from tpo/theme/colors `status`.
 */
export const SEND_MENU_HEADING = "Send to a borrower";

export const SEND_TO_BORROWER_ITEMS = [
  {
    to: "/send/loan-application",
    label: "Loan application",
    description:
      "Send a link to a full application. Prefill anything you already know.",
    icon: DescriptionOutlinedIcon,
    tone: "info",
  },
  {
    to: "/send/credit-auth",
    label: "Credit authorization",
    description: "Request e-signed consent to pull the borrower's credit.",
    icon: CreditCardOutlinedIcon,
    tone: "success",
  },
];
